export const DATAROOMS_LIST_COLUMN_ACCOUNT_NAME = {
  key: "title",
  label: "Fund Name",
  width: 134,
};

export const documentTypeFallbackNames: Record<number, string> = {
  16: "Fund Summary & Due Diligence",
  7: "Legal Documents",
  12: "Private Placement Memorandum",
};

export const documentTypeMap: Record<number, number[]> = {
  16: [49, 52, 53],
  7: [51],
  12: [54],
};

export const documentTypeMapMerge: Record<string, string[]> = {
  "16": ["16", "49", "52", "53"],
  "49": ["16", "49", "52", "53"],
  "52": ["16", "49", "52", "53"],
  "53": ["16", "49", "52", "53"],
  "7": ["7", "51"],
  "51": ["7", "51"],
  "12": ["12", "54"],
  "54": ["12", "54"],
  // add more as needed
};

export const fundSummaryGroup = new Set([16, 49, 52, 53]);

export const DATAROOMS_LIST_COLUMNS = [DATAROOMS_LIST_COLUMN_ACCOUNT_NAME];
